(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/games.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/games.js');
'use strict';

const _svs$ui$ReactForm = svs.ui.ReactForm,
  ControlGroup = _svs$ui$ReactForm.ControlGroup,
  Select = _svs$ui$ReactForm.Select,
  Option = _svs$ui$ReactForm.Option;
const games = svs.selfExclusion.allGames.games;
const _svs$selfExclusion$Co = svs.selfExclusion.Constants,
  isPnp = _svs$selfExclusion$Co.isPnp,
  gamesLabelText = _svs$selfExclusion$Co.gamesLabelText;
const poolsVerticalHelpText = svs.self_exclusion_react.data.poolsVerticalHelpText;
const Games = _ref => {
  let onHandleGame = _ref.onHandleGame,
    game = _ref.game,
    isSubmitted = _ref.isSubmitted;
  const handleChange = gameValue => {
    onHandleGame(gameValue);
  };
  return React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste v\xE4lja ett spel",
    hasError: isSubmitted && !game,
    v2: true
  }, React.createElement("label", {
    className: "styled-label"
  }, gamesLabelText, React.createElement(Select, {
    id: "reactSelect",
    inverted: isPnp,
    onChange: e => handleChange(e.target.value),
    v2: true,
    value: game || ''
  }, React.createElement(Option, null), games.map(game => React.createElement(Option, {
    key: game.id,
    value: game.value
  }, game.label)))), poolsVerticalHelpText && React.createElement("p", {
    className: "help-text"
  }, poolsVerticalHelpText));
};
svs.selfExclusion.components.Games = Games;

 })(window);